import React from "react";
import config from "../../../config";

export default function DemographicsTile({ model, title }) {
  const hideName = (nameValue) => {
    const nameParts = nameValue.split(","); // split the name string into last and first parts
    return `${nameParts[0].trim()[0]}, ${nameParts[1].trim()[0]}`; // need the trim to remove any whitespace from the split
  };

  return (
    <React.Fragment>
      <div className="title">{title}</div>
      <div className="tile-content demographics">
        {model.fields.map((field, i) => (
          <div className="field" key={i}>
            <div className="label">{field.label}</div>
            <div className="value">
              {config.hidePHI && field.label === "Patient Name"
                ? hideName(field.value)
                : field.value}
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}
